import { Component, Input, ViewChild } from '@angular/core';
import { FlowManagerService } from '../../shared/services/flowmanager.service';

@Component({
  selector: 'md-step-title',
  template: require('./stepTitle.component.html')
})

export class StepTitleComponent {
  @Input() form;
  @ViewChild('focusItem') focusItem;

  constructor(flowManager: FlowManagerService) {
    this.flowManager = flowManager;
    this.stepMax = 6;
  }

  ngAfterViewInit() {
    if (this.focusItem) {
      setTimeout(() => {
        this.focusItem.nativeElement.focus();
      }, 0);
    }
  }

  ngOnInit() {
    if (this.flowManager.isAuthed === true) {
      this.stepMax = 5;
    }

    this.stepSubtitle = this.form.stepSubtitle || null;
  }
}
